import { createIcon } from '@chakra-ui/icons';

export const HeartCompact = createIcon({
  displayName: 'HeartCompact',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.475 13.3C5.775 12.6875 0 7.875 0 4.2C0 1.8375 1.925 0 4.2 0C5.25 0 6.2125 0.4375 7 1.05C7.7875 0.35 8.75 0 9.8 0C12.1625 0 14 1.925 14 4.2C14 7.875 8.225 12.6875 7.525 13.2125C7.2625 13.5625 6.7375 13.5625 6.475 13.3ZM4.2 1.75C2.8875 1.75 1.75 2.8875 1.75 4.2C1.75 6.125 4.8125 9.45 7 11.375C8.8375 9.7125 12.25 6.3 12.25 4.2C12.25 2.8 11.1125 1.75 9.8 1.75C9.0125 1.75 8.225 2.1875 7.7875 2.8875C7.4375 3.4125 6.65 3.4125 6.3 2.8875C5.775 2.1875 5.075 1.75 4.2 1.75Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
